import Axios from 'axios';
import { APIBASE_URL, Sale_URL } from '../config/cacheKey';
import { ApiResultModel } from '../models/common.model';
import { ICancelInvoiceByCustomerRequest, IGetCustomerSaleResponse, IGetSaleInfoResponse, IGetWaitForCustomerApproveSalesResponse, ISaleId } from '../models/sale.model';



export const GetCustomerSales = (): Promise<IGetCustomerSaleResponse[]> => {
    return Axios.post<ApiResultModel<IGetCustomerSaleResponse[]>>(
        APIBASE_URL + Sale_URL + '/GetCustomerSales',

    ).then((result) => {
        return result.data.data;
    });
};
export const GetCustomerSale = (data: ISaleId): Promise<IGetCustomerSaleResponse> => {
    return Axios.post<ApiResultModel<IGetCustomerSaleResponse>>(
        APIBASE_URL + Sale_URL + '/GetCustomerSale',
        data
    ).then((result) => {
        return result.data.data;
    });
};

export const CancelInvoiceByCustomer = (data: ICancelInvoiceByCustomerRequest): Promise<boolean> => {
    return Axios.post<ApiResultModel<boolean>>(
        APIBASE_URL + Sale_URL + '/CancelInvoiceByCustomer',
        data
    ).then((result) => {
        return result.data.data;
    });
};





export const GetWaitForCustomerApproveSales = (): Promise<IGetWaitForCustomerApproveSalesResponse[]> => {
    return Axios.get<ApiResultModel<IGetWaitForCustomerApproveSalesResponse[]>>(
        APIBASE_URL + Sale_URL + "/GetWaitForCustomerApproveSales"
    ).then((result) => {
        return result.data.data;
    });
};


export const GetSaleInfo = (refKey: string): Promise<IGetSaleInfoResponse> => {
    return Axios.get<ApiResultModel<IGetSaleInfoResponse>>(
        `${APIBASE_URL}${Sale_URL}/GetSaleInfo/${refKey}`
    ).then((result) => {
        return result.data.data;
    });
};



